import TabsManager from "../../js/components/tabsManager";

export default class TabsMenu extends HTMLElement {
    constructor() {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.tabsTitle = JSON.parse(this.getAttribute('tabs-title'));
        this.tabSelected = JSON.parse(this.getAttribute('tab-selected'));
    }

    static get observedAttributes() {
        return ['stylesheet', 'tabs-title', 'tabs-title-padding'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name == 'tabs-title') {
            this.tabsTitle = JSON.parse(newValue);
        }
        if (name == 'tabs-title-padding') {
            this.tabsTitlePadding = JSON.parse(newValue);
        }
        if (name == 'stylesheet') {

            this.stylesheet = newValue;
        }
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const template = document.querySelector('#tabs-menu');
        this.instance = template.content.cloneNode(true);

        if (this.stylesheet !== undefined) {
            this.tabsManager = new TabsManager(this.instance.querySelector('.tabs-menu-container'));

            this.instance.querySelector('[name="stylesheet"]').addEventListener('load', () => {
                this.style.display = ''
            });
            this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

            this.hotelRatingTabs = this.instance.querySelector('[name="tabs-menu"]');

            if (this.tabsTitlePadding) {
                this.hotelRatingTabs.classList.add('tabs-title-padding');
            }

            this.buildTabs();
            if (this.tabSelected) {
                this.instance.querySelector('[data-anchor-id="' + this.tabSelected + '"]').click();
            }

            this._shadowRoot.appendChild(this.instance);

        }
        return this._shadowRoot;
    }

    buildTabs(pointerAll = false) {
        let tabsTitle = Object.entries(this.tabsTitle);
        let tabsMenu = this.instance.querySelector('[data-container="tabs-menu"]') || this._shadowRoot.querySelector('[data-container="tabs-menu"]');
        for (let [key, tabTitle] of tabsTitle) {
            let ratingTabTemplate = document.querySelector('#tab-option');
            let ratingTabInstance = ratingTabTemplate.content.cloneNode(true);
            let ratingTabTitle = ratingTabInstance.querySelector('[name="tab-title"]');
            if (tabsTitle.length > 1 || pointerAll) {
                tabsMenu.classList.add('pointer');
            }
            ratingTabTitle.dataset.tabEntity = key;
            let titleImg = null;
            let titleText = null;
            let appendTab = true;
            for (let [type, titleParam] of Object.entries(tabTitle)) {
                if (type == 'img') {
                    titleImg = document.createElement('img');
                    titleImg.src = titleParam;
                    titleImg.alt = key;
                }
                if (type == 'text') {
                    titleText = document.createElement('div');
                    titleText.innerHTML = titleParam;
                    titleText.classList.add('text-bold', 'ml-2');
                }
                if (type == 'anchorId') {
                    ratingTabTitle.dataset.anchorId = titleParam;
                }
                if (type == 'clickElement') {
                    ratingTabTitle.addEventListener('click', () => {
                        document.querySelector(titleParam).click();
                    }, {once: true});
                }
                if (type == 'reviewsToShow' && !tabTitle.reviewsToShow) {
                    appendTab = false;
                }
            }
            if (titleImg) {
                ratingTabTitle.appendChild(titleImg);
            }
            if (titleText) {
                if (!titleImg) {
                    titleText.classList.remove('ml-2');
                }
                ratingTabTitle.appendChild(titleText);
            }

            if (appendTab) {
                this.hotelRatingTabs.appendChild(ratingTabTitle);
            }
        }

        this.tabsManager.loadTabs('data-tab-entity', this.querySelectorAll('[data-tab-entity]'));
    }
}
